import { render, staticRenderFns } from "./CustomHomeButton.vue?vue&type=template&id=636edece&scoped=true&"
import script from "./CustomHomeButton.vue?vue&type=script&lang=js&"
export * from "./CustomHomeButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomHomeButton.vue?vue&type=style&index=0&id=636edece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636edece",
  null
  
)

export default component.exports